


















import Component, { mixins } from "vue-class-component";
import Moment from "moment-timezone";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import PageTitle from "@/components/PageTitle.vue";
import { fields } from "./config";
import { FormFields, FormValues } from "@/types";
import { Dictionary } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import WithUser from "@/mixins/WithUser";
import { InputUserCreate } from "@teacherskaya/api-provider/dist/api/UserProvider";

const generateScreenName = (email: string) => {
  return email.split("@")[0];
};

@Component({
  name: "BlockAddUser",
  components: { BlockBaseForm, BlockBase, PageTitle },
})
export default class BlockAddUser extends mixins(WithUser) {
  public fieldsErrors: Dictionary<string[]> = {};

  get fields(): FormFields {
    return fields.map(item => {
      if (item.name === "role" && item.list) {
        item.value = (item.list.find(role => role.value === "member") || item.list[0]).value || "";
      }
      return item;
    });
  }

  public async save(values: FormValues) {
    if (!values.email || values.email.length === 0) {
      this.$set(this.fieldsErrors, "email", [$t("Email is required")]);
      return;
    }
    if (!values.password || values.password.length === 0) {
      this.$set(this.fieldsErrors, "password", [$t("Password is required")]);
      return;
    }
    let data: InputUserCreate = {
      timeZone: Moment.tz.guess(true),
      email: values.email,
      password: values.password,
      role: values.role,
      screenName: generateScreenName((values.email && values.email.toString()) || "user"),
    };
    this.$emit("created", await this.userAdd(data));
  }

  public cancel() {
    this.$emit("cancel");
  }
}
